import _ from "underscore";
import styled from "@emotion/styled";

export const ClickMappingsContainer = styled.div`
  margin-top: 1rem;
`;

export const ActionPickerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 30rem);
  overflow-y: auto;
`;
